import axios from '../axios/ajax'
import {Message} from 'element-ui'
import $router from '@/router'

//会影响待办提醒的请求
import {backlogurls,driverurls} from '@/router/router-url';
import {routerDrive} from '@/router/router-code'

export default function start(Vm, callback){
  //响应拦截器即异常处理

  axios.interceptors.response.use(response => {
    var requestUrl = response.config.url;
    if(requestUrl.indexOf('?')>-1){
      requestUrl=requestUrl+"&radom="+Math.random();
    }else{
      requestUrl=requestUrl+"?radom="+Math.random();
    }
    //登录失效返回登录页面
    let data = response.data;
    // session失效的返回--失效跳转后台有控制，这里注释没什么用
    if(data.code==3){
      window.location.href = "/commonlogin/#/login";
    }else if(data.code === -1 && data.message === '没有权限'){// 如果操作项没有权限跳转到无权限页面
      //这里对登录路径请求做了筛选（由于平台，登录失败和没有权限返回的CODE都是-1，所以这里无法通过CODE区分是否登录页面）
      // if(!(requestUrl.indexOf('login')>-1)){
      //   const {href,origin,pathname}=window.location;
      //   const sliceIdx=href.indexOf('?');
      //   const params=sliceIdx>-1?(href.slice(sliceIdx)):''
      //   if (window.location.href.indexOf('project-entry')>-1) {
      //     setTimeout(() =>   window.location.href = origin+pathname+"#/project-entry/nopower" + params, 300);
      //   }else{
      //     setTimeout(() =>   window.location.href = origin+pathname+"#/index/nopower" + params, 300);
      //   }
      // }
      Message({
        message: data.message,
        type: 'warning'
      })
      $router.replace('/login')
      return
    }
    // 待办提醒
    for(var i=0;i<backlogurls.length;i++){
      if(requestUrl.indexOf(backlogurls[i])!=-1){
        console.log(requestUrl.indexOf(backlogurls[i])!=-1);
        var menus = vueA.$store.state.apiList;
        var myArray=new Array();
        for (var j = 0; j < menus.length; j++) {
          var resCode = menus[j]
          myArray.push(resCode);
        }
        console.log("myArray:"+myArray);
        vueA.$ajax.post(process.env.API_HOST + 'backlog-quantity/getBacklogQuantity',myArray).then((res) => {
          console.log(res.data.data)
          vueA.$store.state.redD=res.data.data;
        });
      }
    }

    //项目驱动菜单重新刷新
    for(var i=0;i<driverurls.length;i++){
      if(requestUrl.indexOf(driverurls[i])!=-1){
        console.log("项目驱动请求路径:"+driverurls[i]);
        let param = Object.assign({}, {
          projectId: vueA.$store.state.projectId
        });
        vueA.$ajax.get(process.env.API_HOST + "menu/getMenuTree", {params:param}).then((res) => {
          if(res && res.status == 200) {
            let resultData = res.data;
            console.log(resultData.menu);
            let menus = resultData.menu;
            // console.log('----',this.mockData[0].son);
            vueA.$store.state.projectDriver[0].son = assembleFictitiousMenu(menus);
            setInitData();
          } else {
          }
        })
      }
    }
    /*    //项目驱动路径
        driverurls.forEach(item => {
          //  alert(requestUrl+":"+item);
          if(requestUrl == item){
            let param = Object.assign({}, {
              projectId: vueA.$store.state.projectId
            });
            vueA.$ajax.get(process.env.API_HOST + "menu/getMenuTree", {params:param}).then((res) => {
              if(res && res.status == 200) {
                  let resultData = res.data;
                  console.log(resultData.menu);
                  let menus = resultData.menu;
                  // console.log('----',this.mockData[0].son);
                  vueA.$store.state.projectDriver[0].son = assembleFictitiousMenu(menus);
                  setInitData();
              } else {
              }
            })
          }
        })*/


    return response
  }, err => {
    console.log("err--------",err)
    if (err && err.response) {
      //ajax异常状态
      switch (err.response.status) {
        case 400:
          console.log('错误请求')
          break;
        case 401:
          console.log('SESSION失效')
          const loginForm=localStorage.loginForm;
          sessionStorage.clear();
          Message({
            message: '已经超时，请重新登录',
            type: 'warning'
          })
          loginForm ? (
            localStorage.removeItem('loginForm'),
            window.location.href = "/"+loginForm+"/#/login"
          ):(
            $router.replace('/login')
          )
        case 403:
          console.log('拒绝访问')
          break;
        case 404:
          console.log('请求错误,未找到该资源')
          break;
        case 405:
          console.log('请求方法未允许')
          break;
        case 408:
          return Message({
            message: '请求超时',
            type: 'warning'
          });
        case 500:
          console.log('服务器端出错')
          break;
        case 501:
          console.log('网络未实现')
          break;
        case 502:
          console.log('网络错误')
          break;
        case 503:
          console.log('服务不可用')
          break;
        case 504:
          console.log('网络超时')
          break;
        case 505:
          console.log('http版本不支持该请求')
          break;
        default:
          console.log('连接错误'+err.response.status)
      }
    } else {
      console.log('连接到服务器失败')
    }
    return Promise.resolve(err.response)
  })


  Vm.prototype.$ajax = axios;

  var vueA = callback(Vm);

  // 初始化数据
  function setInitData(){
    let tmpData = vueA.$store.state.projectDriver;
    let that = vueA;
    console.log('vm=>>>>>',this);
    vueA.$nextTick(() => {
      let itemActive = that.$refs.siderActive;
      let titleActive = that.$refs.spanBlue;
      for(let i=0; i<tmpData.length; i++){
        let tmpVal = tmpData[i].son;
      }
    });

  }

  function  assembleFictitiousMenu(menus) {//组装虚拟菜单树信息
    let firstLevelList = menus.children; // 去掉虚节点
    let son = []; //定义所有的子菜单数
    for (let firstIndex = 0; firstIndex < firstLevelList.length; firstIndex++) { // 第一层菜单循环
      let tmpFictitiousMenu  = {
        num:0,
        sontitle:"",
        isBlue:false,
        info:[]
      };
      let firstRes = firstLevelList[firstIndex];
      let menuIndex = firstIndex + 1
      tmpFictitiousMenu.num = menuIndex;
      tmpFictitiousMenu.sontitle = firstRes.resName;
      tmpFictitiousMenu.isBlue = firstRes.disabled;
      //tmpFictitiousMenu.isBlue = true;
      tmpFictitiousMenu.info = assembleMenu(firstRes.children);
      son[firstIndex] = tmpFictitiousMenu;
    }
    return son;
  }



  function  assembleMenu(menus){ //组装菜单树
    var index = 0;
    let menusArray = [];
    for (let menuIndex = 0; menuIndex < menus.length; menuIndex++) {
      let childrenMenu = menus[menuIndex];
      let tempMenu = {
        num:0,
        name:"",
        routes:"",
        isDisabled:false,
      };
      tempMenu.num =  index;
      index = index + 1;
      tempMenu.name = childrenMenu.resName;
      tempMenu.routes = '/project-entry/'+ routerDrive[childrenMenu.resCode];
      tempMenu.isDisabled = childrenMenu.disabled;//等平台调整好了，在换成否!childrenMenu.disabled
      //tempMenu.isDisabled = false;
      menusArray[menuIndex] = tempMenu;
    }
    return menusArray;
  }
  return vueA;
}



// WEBPACK FOOTER //
// ./src/extend/backlog.js